import React, { useEffect, useState } from 'react'
import { Box, Typography, Card, CardContent, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { WebContext } from '../../contextProvider/webContextProvider';
import { cardProperty } from '../../constants/styles';
import { LeadFormMilitaryAffiliationName, LeadFormMilitaryAffiliationTitle, LeadFormMilitaryConfirmation, LeadFormMilitaryOptions } from '../../constants/leadForms';

const LeadFormMilitary = ({ onNext, leadFormData, setLeadFormData }: any) => {
  const { webContent } = React.useContext(WebContext);
  const [isYesClicked, setIsYesClicked] = useState<Boolean>(false);
  const [isMilitaryChange, setIsMilitaryChange] = useState('')
  const [selectedCard, setSelectedCard] = useState(null);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  const handleCardClick = (confirmName: any) => {
    setLeadFormData({ ...leadFormData, military: confirmName });
    setIsYesClicked(confirmName === 'Yes');
    setSelectedCard(confirmName)
    if (confirmName === 'No') {
      onNext();
    }
  };

  const handleChangeMilitary = (event: any) => {
    setLeadFormData({ ...leadFormData, militaryAffiliationName: event.target.value });
    setIsMilitaryChange(event.target.value)
    onNext();
  }

  return (
    <Box>
      <Box textAlign='center'>
        <Typography component="h5" fontSize="30px" maxWidth="600px" lineHeight="1.3" mx="auto" fontWeight="800" mb={2}>{LeadFormMilitaryAffiliationTitle}</Typography>
      </Box>
      <Box display='flex' mt={[8,0]} flexWrap='wrap' justifyContent='center' gap="30px" maxWidth="510px" mx="auto">
        {LeadFormMilitaryConfirmation.map((confirm:any, index:any) =>
          <Card sx={{
            '&:hover': {
              outline: `2px solid ${webContent?.defaultData?.primaryColor}`,
            },
            ...cardProperty
          }} key={index} onClick={() => handleCardClick(confirm.name)}
            className={`frm-card ${selectedCard === confirm.name ? 'selected' : ''}`}
          >
            <img src={confirm.src} alt='icons' />
            <CardContent sx={{ p: "0 !important" }}>
              <Typography fontWeight="600" lineHeight="1.3" fontSize="14px" px={2} sx={{ height: "48px" }}> {confirm.name} </Typography></CardContent>
          </Card>
        )}
      </Box>

      {isYesClicked && (
        <Box mt={5}>
          <Box textAlign="center">
            <Typography component="h6" fontSize="22px" maxWidth="600px" lineHeight="1.3" mx="auto" fontWeight="800">{LeadFormMilitaryAffiliationName}</Typography>
          </Box>

          <FormControl sx={{ width: "300px", display: "flex", m: "18px auto 0" }}>
            <InputLabel>Military Affiliation</InputLabel>
            <Select sx={{ backgroundColor: '#ffffff !important' }}
              value={isMilitaryChange}
              onChange={handleChangeMilitary}
              label="Military Affiliation"
            >
              {LeadFormMilitaryOptions.map((military:any,index:any) =>
                <MenuItem key={index} value={military as any}>{military.name}</MenuItem>
              )}
            </Select>
          </FormControl>
        </Box>
      )
      }
    </Box >
  )
}

export default LeadFormMilitary